<template>
  <!--快捷入口-->
  <div class="shortcut">
    <div class="item-list" :class="{len3:data.length<4}">
      <!-- 数据完成加载时，展示正常数据 -->
      <div class="item" v-for="(item, index) in data" v-if="loadDone" @click="toDestination(item, index)"
        data-mta="true">
        <div class="item-tag" v-if="item.tagPic"
          :style="{ 'background-image': item.tagPic && `url(${cosPrefix}${item.tagPic})` }"></div>
        <BtnWave :speed="4" :opacity="0.2" :style="{ 'background-image': item.pic && `url(${cosPrefix}${item.pic})` }">
          <b>{{ item.title }} </b>
          <span>{{ item.desc }}</span>
        </BtnWave>
      </div>
      <!-- 数据未完成加载时，显示三个灰色占位按钮 -->
      <div class="item loading" v-if="!loadDone">
        <BtnWave :speed="4" :opacity="0.2"></BtnWave>
      </div>
      <div class="item loading" v-if="!loadDone">
        <BtnWave :speed="4" :opacity="0.2"></BtnWave>
      </div>
      <div class="item loading" v-if="!loadDone">
        <BtnWave :speed="4" :opacity="0.2"></BtnWave>
      </div>
    </div>
  </div>
</template>

<script>
import BtnWave from '@/components/common/BtnWave'
import { jumpLink, MtaH5ClickStat } from '@/assets/js/util'

export default {
  name: 'Shortcut',
  components: { BtnWave },
  props: {
    data: { type: [Array, Object] },
    loadDone: {
      type: Boolean,
      default: false
    },
    org: { type: [Array, Object] }
  },
  data () {
    return {
      cosPrefix: cos_prefix
    }
  },
  methods: {
    toDestination (item, index) {
      if (this.$route.path === '/') {
        // 首页埋点
        let obj = {}
        let key = 'd' + (index + 1)
        obj[key] = 'true'
        MtaH5ClickStat(obj)
      }
      setTimeout(() => {
        if (!item.url) {
          this.$toast('暂未开放，敬请期待')
          return
        }
        // 判断是否是本地路由url，是则跳转至本地路由，否则正常跳转
        if (this.$route.name === 'org-detail') {
          item.url =
            item.url.indexOf('?') === -1
              ? `${item.url}?city=${this.org.city}`
              : `${item.url}&city=${this.org.city}`
        }
        jumpLink({
          vm: this,
          url: item.url,
          isReplaceRouter: false
        })
      }, 200)
    }
  }
}
</script>

<style lang="less" scoped>
// @import "../../assets/css/variable";
@image: "../../assets/images/";
// shortcut超过3个时
.shortcut-bg-loop(@n, @i:1) when (@i <= @n) {
  &:nth-child(@{i}) .btn-wave {
    background-image: url("@{image}org/shortcut/img_0@{i}.png");
  }
  .shortcut-bg-loop(@n, (@i + 1));
}
// shortcut 小于3个时显示另一套bg
.len3-shortcut-bg-loop(@n, @i:1) when (@i <= @n) {
  &:nth-child(@{i}) .btn-wave {
    background-image: url("@{image}shortcut-bg-@{i}.png");
  }
  .len3-shortcut-bg-loop(@n, (@i + 1));
}

.shortcut {
  // height: 196/200rem;
  padding: 40/200rem 0/200rem 0/200rem 30/200rem;

  .item-list {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    &.len3 {
      .item {
        .len3-shortcut-bg-loop(3);
      }
    }
    .item {
      position: relative;
      margin-bottom: 16/200rem;
      margin-right: 30/200rem;
      .shortcut-bg-loop(9);
      &.loading .btn-wave {
        background: rgba(0, 0, 0, 0.05);

        b,
        span {
          color: transparent;
        }
      }
      .item-tag {
        position: absolute;
        top: -16/200rem;
        right: -23/200rem;
        z-index: 9;
        width: 110/200rem;
        height: 65/200rem;
        pointer-events: none;
        background-size: 100% 100%;
      }
      .btn-wave {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 210/200rem;
        height: 124/200rem;
        border-radius: 12/200rem;
        color: #fff;
        font-size: 0;
        text-align: center;
        background-size: 100% 100%;

        b {
          padding: 2.5/200rem;
          line-height: 1.2;
          font-size: 30/200rem;
          font-weight: 600;
        }
        span {
          padding: 2.5/200rem;
          line-height: 1.2;
          font-size: 22/200rem;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
